import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import tick from '../../../../../../../assets/images/tick.svg';
import theme from '../../../../../../../theme';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-success.module.scss';
import Header from '../../../../../../../components/Stake/header';
import * as bcubeStakeActions from '../../../../../../../actions/bcube-stake-actions';
import { formatToken } from '../../../../../../../helpers/token-helper';
import BcubeIcon from '../../../../../../../assets/images/BCUBE.svg';
import TxID from '../../../../../../../components/txID';
import { BCUBE } from '../../../../../../../constants/blockchain-constants';

const StakeSuccess = () => {
  const dispatch = useDispatch();
  const { id, amount } = useSelector((state) => state.BCUBEstake.stake);

  return (
    <>
      <Header icon={BcubeIcon} title={`${BCUBE}-Staking`} />
      <div className={stylesParent.cardContent}>
        <div className={styles.icon}>
          <img src={tick} alt='' />
        </div>
        <div className={styles.stakedValue} style={{ color: theme.palette.mantra.pink }}>
          {formatToken(amount)} {BCUBE}
        </div>
        <div className={styles.status}>Staked</div>
        <TxID id={id} />
        <div>
          <div className={styles.description}>
            Congrats, you are now earning daily staking rewards! You may{' '}
            <b>unstake a portion or all</b> your tokens at any time followed by an{' '}
            <b>8 day withdrawal period.</b>
          </div>
          <div className={styles.description}>
            <b className={styles.descriptionAccent}>IMPORTANT!</b> Earned rewards are now staked
            automatically.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(bcubeStakeActions.stakeReset())}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Done
          </Button>
        </div>
      </div>
    </>
  );
};

export default StakeSuccess;
